module.exports = __webpack_public_path__ + "static/tutor-screen@2x-51096bcc17c4efe7addd30cf34f4293b.png";